import React, { useState } from "react";
import { SEARCH } from "../../../core/theme/searchTheme";
import { lookupPostcode, normalisePostcode } from "../../../core/api/postcodesApi";

// Optional: the user's own business. Its postcode becomes the dark pin on the
// map and, once found, the first business location: the radius in Locations
// is centred on it.
export default function BusinessSection({ form }) {
  const { business, updateBusiness } = form;
  const [error, setError] = useState("");

  const checkPostcode = async () => {
    const text = business.postcode.trim();
    if (!text) { setError(""); return; }
    const place = await lookupPostcode(text);
    if (!place) {
      setError(`"${normalisePostcode(text)}" isn't a UK postcode we can find.`);
      return;
    }
    setError("");
    updateBusiness({ postcode: place.postcode, lat: place.lat, lng: place.lng, places: place.places });
  };

  return (
    <div>
      <div className={SEARCH.sectionHeader}>
        <span className={SEARCH.sectionTitle}>Your business</span>
        <span className={SEARCH.sectionHint}>Optional · its postcode is the centre of the search</span>
      </div>
      <div className="flex gap-2">
        <input className={SEARCH.inputSmall} placeholder="Business name" value={business.name} onChange={e => updateBusiness({ name: e.target.value })} />
        <input
          className={`${SEARCH.inputSmall} !w-28 shrink-0`}
          placeholder="Postcode"
          value={business.postcode}
          onChange={e => { updateBusiness({ postcode: e.target.value, lat: null, lng: null, places: [] }); setError(""); }}
          onBlur={checkPostcode}
          onKeyDown={e => { if (e.key === "Enter") checkPostcode(); }}
        />
      </div>
      <input className={`${SEARCH.inputSmall} mt-1.5`} placeholder="Website, e.g. smithplumbing.co.uk" value={business.website} onChange={e => updateBusiness({ website: e.target.value })} />
      {error && <p className={SEARCH.error}>{error}</p>}
    </div>
  );
}
